var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKumbangTextLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 18,
    viewBox: "0 0 69 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116130",
    d: "M11.358 0H1.914v2.32h9.444v3.093H0v2.448h15.442V5.413h-1.4V0h-2.68z",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    },
    transform: "translate(.808 .881)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116131",
    d: "M14.5 11.274H2.414v6.78H14.5v-6.78zm-9.4 4.408h6.715v-2.035H5.1z",
    transform: "translate(.354 -1.24)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116132",
    d: "M56.639 0H44.515v2.32h9.444v3.093H42.6v2.448h15.442V5.413h-1.4V2.32z",
    transform: "translate(-7.207 .881)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116133",
    d: "M57.094 11.274H45.008v6.78h12.086v-6.78zm-9.4 4.407h6.714v-2.034h-6.714z",
    transform: "translate(-7.66 -1.24)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116134",
    d: "M34.268 0h2.68v6.443h-2.68zm0 7.481V6.443h4.977v2.32h-2.787a4.325 4.325 0 0 0-2.19-1.282z",
    transform: "translate(-5.639 .881)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116135",
    d: "M21.064 0h2.68v2.32h2.935V0h2.808v7.459a5.047 5.047 0 0 0-2.481 1.3h-.326V4.382h-2.936V6.83h2.935v1.933h-5.615V2.32zm13.273 12.307a3.893 3.893 0 1 1-3.892-3.93 3.911 3.911 0 0 1 3.892 3.93zm-5.494 0a1.6 1.6 0 1 0 1.6-1.617 1.609 1.609 0 0 0-1.6 1.617z",
    transform: "translate(-3.155 .881)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116136",
    d: "M78.209 14.248a3.893 3.893 0 1 1-3.892-3.93 3.911 3.911 0 0 1 3.892 3.93zm-5.494 0a1.6 1.6 0 1 0 1.6-1.617 1.609 1.609 0 0 0-1.6 1.617z",
    transform: "translate(-12.441 -1.06)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116137",
    d: "M76.869 0h2.68v6.443h-2.68zm0 7.481V6.443h4.977v2.32h-2.787a4.325 4.325 0 0 0-2.19-1.282z",
    transform: "translate(-13.654 .881)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116138",
    d: "M66.345 0h-2.68v8.763h5.927a4.75 4.75 0 0 1 2.369-1.3V0H69.28v2.32h-2.935zm2.935 4.382h-2.935V6.83h2.935z",
    transform: "translate(-11.17 .881)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKumbangTextLogo);
export default __webpack_public_path__ + "static/media/kumbang-text-logo.11beb17675b2eee4357b95ff15d80f08.svg";
export { ForwardRef as ReactComponent };